export default __webpack_public_path__ + "maps-guides-styles-layers-sky-layer-1200-669a23bf01516a007210bc74aeac6b9b.webp";